import axios from 'axios';
import { SerializedError } from '@reduxjs/toolkit';

export const sendError = (error: Error | SerializedError) => {
  console.error(error);
  const { message, name, stack } = error;

  try {
    axios.post('/spapi/errors', { message, name, stack });
  } catch (axiosError) {
    console.error(axiosError);
  }
};
